import { useCallback } from 'react';

import type { PinData } from '../../Map.types';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Hook to handle callout press events.
 * This hook is shared between native and web implementations.
 */
export const useCalloutPress = (params: Params) => {
  const { activePin, onCalloutPress } = params;

  return useCallback(() => {
    if (!activePin) return;

    onCalloutPress?.({
      restaurantId: activePin.id,
      restaurantName: activePin.name,
      restaurantSlug: activePin.restaurantSlug,
    });
  }, [onCalloutPress, activePin]);
};

// ─── Types ───────────────────────────────────────────────────────────────────

type Params = {
  activePin: PinData | undefined;
  onCalloutPress?: (params: {
    restaurantId?: string;
    restaurantName?: string;
    restaurantSlug?: string;
  }) => void;
};
